var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.getClass,attrs:{"type":"button","disabled":_vm.disabled,"aria-label":_vm.$attrs.title || _vm.icone},on:{"click":function($event){return _vm.handleClick($event)}}},[_c('b-icon',{staticClass:"bIcone",attrs:{"icon":_vm.icone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }